import React from 'react';
import { TouchableOpacity, View, Text, LayoutChangeEvent, } from 'react-native';
import { Feather, FontAwesome5, Foundation, } from '@expo/vector-icons';
import {Connection, ConnectionOrd, ConnectionMkt, ISettings, } from '../~Utilities/Connection';
import {TransactionType} from '../~Utilities/Rq';
import {Data, PosData} from '../~Utilities/Data';
import QB from '../~Screens/QB';
import TextWithImage from '../C_Text/TextWithImage';
import ModalEx from './ModalEx';
import { AppMain, FontInfo } from '../~Utilities/Constants';
import Utilities from '../~Utilities/Utilities';
import OBControl from './OBControl';

/*   ------------------------------------------------------------------------   */

// function IsLoggedIn() : boolean
// {
// if (ConnectionOrd.bSettingsLocal == true)
//   {
//   if (ConnectionMkt.oConn)
//     return(ConnectionMkt.oConn?.GetLoginStatus());
//   else
//     return(false);
//   }

// if (ConnectionOrd.oConn)
//   return(ConnectionOrd.oConn?.GetLoginStatus());
// else
//   return(false);
// }

/*   ------------------------------------------------------------------------   */

interface OrderState 
  {
  visible            : boolean,
  pos_data?          : PosData,

  rev_pos_enabled    : boolean,
  can_all_enabled    : boolean,
  ftn_pos_enabled    : boolean,

  confirm_actions    : boolean,
  }

  /*   ------------------------------------------------------------------------   */

const B_BIG   = 60;
const B_SMALL = 50;

/*   ------------------------------------------------------------------------   */

export interface IOrder
{
  oData           : Data;

  qbRef?          : React.RefObject<QB>;
  
  bindEvent       : (onEvent    : (() => void), 
                     bSubscribe : boolean) => void
}

/*   ====================================================================   */

export default class Order extends React.Component<IOrder>
 {
   oTimeOut?     : NodeJS.Timeout;
   oOBControls   : OBControl | null = null;
   iControlWidth : number           = Utilities.WIDTH-100;
   
   //sSvAccount? : string;

   /*   -------------------------------------------------------------------   */

   Refresh()
   {
     //alert("refreshing...");
     this.forceUpdate();
   }

  /*   -------------------------------------------------------------------   */

  HideModal()
  {
  ModalEx.oModalEx?.Hide();

  this.setState({visible            : false, 
                 });
  }

  /*   -------------------------------------------------------------------   */

  componentDidMount() 
  {
  this.props.bindEvent(this.UpdateData, true);
  }

  /*   -------------------------------------------------------------------   */

  componentWillUnmount() 
  {
  this.props.bindEvent(this.UpdateData, false);

  if (this.oTimeOut)
    {
    clearTimeout(this.oTimeOut);
    this.oTimeOut = undefined;
    }

  this.props.qbRef?.current?.oOrderRef?.ApplySettings(this.OnConfirmApply, false);
  }

  /*   ------------------------------------------------------------------   */

  UpdateData()
  {
  if (Connection.oAccStore.size > 0 && 
      this.state.pos_data       == undefined)
    {
    this.setState({pos_data: ConnectionOrd.GetPosData(this.props.oData, this.props.oData.sv_account)}); 
    }
  }

  /*   ------------------------------------------------------------------   */

  GetAccounts()
  {
    let oAccs = new Array(0);

    for (let [key, value] of Connection.oAccStore.entries())
      {
      oAccs.push({label:value.acc_id, value:key, key:key});

      //Utilities.Sendlog("adding key: " + key);
      }

    // if (!this.state.pos_data)
    //   {
    //   let oPosData = this.GetData();

    //   if (oPosData != undefined)
    //     this.setState({pos_data:oPosData});

    //   Utilities.Sendlog("acc key: " + oPosData?.acc_key + " size: " + oAccs.length);
    //   }

    //if (oAccs.length == 0)  
    //  oAccs.push({label:"21", value:"2", key:"2"});

    return(oAccs);  
  }

  /*   -------------------------------------------------------------------   */

    constructor(props)
    {
    super(props);

    this.Refresh               = this.Refresh.bind(this);
    //this.GetData             = this.GetData.bind(this);
    this.HideModal             = this.HideModal.bind(this);
    this.SelectAccount         = this.SelectAccount.bind(this);
    this.SelectAccountForce    = this.SelectAccountForce.bind(this);
    this.UpdateData            = this.UpdateData.bind(this);

    //  this.GetPNLColor       = this.GetPNLColor.bind(this);
    this.GetPosColor           = this.GetPosColor.bind(this);
    this.GetOrdColor           = this.GetOrdColor.bind(this);
    this.Reset                 = this.Reset.bind(this);
    //this.SetConfirmActions = this.SetConfirmActions.bind(this);
    this.OnConfirmApply        = this.OnConfirmApply.bind(this)
    this.GetDefaultControlPage = this.GetDefaultControlPage.bind(this);

    let bConfirm = false;

    if (this.props.qbRef?.current?.oOrderRef)
      {
      bConfirm = this.props.qbRef?.current?.oOrderRef?.state.confirm_actions;

      this.props.qbRef?.current?.oOrderRef?.ApplySettings(this.OnConfirmApply, true);
      }

    //if (this.props.oData.token == "ES.CME")
    //alert(bConfirm);

    // let z = Utilities.FindItem(ConnectionOrd.oSettings, this.props.oData.token);
    // let oSett : ISettings | undefined;
    
    // if (z != AppMain.IMAGINARY)
    //   {
    //   oSett           = ConnectionOrd.oSettings[z];
    //   this.sSvAccount = oSett?.sAccount;
    //   }

    let oPosData   = ConnectionOrd.GetPosData(this.props.oData, this.props.oData.sv_account);

    this.state      = {visible:false, 
                       pos_data: oPosData,

                       rev_pos_enabled:!bConfirm,
                       can_all_enabled:!bConfirm,
                       ftn_pos_enabled:!bConfirm,

                       confirm_actions:bConfirm,
                       };
    }

  /*   -------------------------------------------------------------------   */

  GetDefaultControlPage()
  {
    let z = Utilities.FindItem(ConnectionOrd.oSettings, this.props.oData.token);
    let oSett : ISettings | undefined;
    
    if (z != AppMain.IMAGINARY)
      {
      oSett = ConnectionOrd.oSettings[z];

      if (oSett.iControlPage)
        return(oSett.iControlPage);
      }

  return(0);
  }

  /*   -------------------------------------------------------------------   */

  OnConfirmApply(iMsg  : number, 
                 bApply: boolean)
  {
  //alert(bApply);
  clearTimeout(this.oTimeOut);
  this.oTimeOut = undefined;

  this.oOBControls?.Refresh();

  this.setState({
                rev_pos_enabled:!bApply,
                can_all_enabled:!bApply,
                ftn_pos_enabled:!bApply,

                confirm_actions:bApply,
                });
  }

  /*   -------------------------------------------------------------------   */

  // public ShowSymbolProps()
  // {
  // ModalEx.oModalEx?.Show();  
  // this.setState({conf_visible:false, sym_prop_visible:true});  
  // }

  /*   -------------------------------------------------------------------   */

  SelectAccount(oData : PosData)
  {
  if (this.state.pos_data?.acc_key != oData.acc_key)
    {
    this.setState({pos_data: oData});
    }
  
  }

  /*   -------------------------------------------------------------------   */

  SelectAccountForce(oData : PosData)
  {
  if (this.state.pos_data?.acc_key != oData.acc_key ||
     this.state.pos_data?.token    != oData.token)
    {
    this.setState({pos_data: oData});
    }

  this.forceUpdate();
  }

  /*   -------------------------------------------------------------------   */

  // ChangeAccount(sAccKey : string)
  // {
  // //alert(sAccId + "/" + this.state.pos_data?.acc_id);

  // if (sAccKey != this.state.pos_data?.acc_key)
  //   {
  //   this.setState({pos_data: this.GetData(sAccKey)});
  //   //this.forceUpdate();
  //   }
  // }

  /*   -------------------------------------------------------------------   */

  state : OrderState = {visible:false, 
                        rev_pos_enabled:false,
                        can_all_enabled:false,
                        ftn_pos_enabled:false,

                        confirm_actions:true,
                        };

  /*   ---------------------------------------------------------------------   */

//   GetPNLColor()
//   {
//   if (this.state.pos_data?.net_qty != undefined &&
//       this.state.pos_data?.net_qty != 0)
//     {
//     if (this.state.pos_data?.open_pnl == undefined)
//       return('gainsboro')
//     else if (this.state.pos_data?.open_pnl >= 0)
//       return('green')
//     else
//       return('red')
//     }
// else
//     {
//     if (this.state.pos_data?.closed_pnl == undefined ||
//         !this.state.pos_data?.closed_pos_qty)
//       return('gainsboro')
//     else if (this.state.pos_data?.closed_pnl >= 0)
//       return('green')
//     else
//       return('red')
//     }
//   }

  /*   ---------------------------------------------------------------------   */

  GetPosColor()
  {
    if (this.state.pos_data?.net_qty == undefined ||
        this.state.pos_data?.net_qty == 0)
      return('gainsboro')
    else if (this.state.pos_data?.net_qty > 0)
      return('dodgerblue')
    else
      return('hotpink')
  }

  /*   ---------------------------------------------------------------------   */

  // SetConfirmActions(bConfirm : boolean)
  // {
  //   if (bConfirm)
  //     this.setState({rev_pos_enabled:true, can_all_enabled:true, ftn_pos_enabled:true});
  //   else
  //     this.setState({rev_pos_enabled:false, can_all_enabled:false, ftn_pos_enabled:false});
  // }

  // /*   ---------------------------------------------------------------------   */

  GetOrdColor()
  {
  if (this.state.pos_data                       == undefined ||
      this.state.pos_data.orders_working        == undefined ||
      this.state.pos_data.orders_working.length == 0)
    return('gainsboro');
  else if (this.state.pos_data.order_buy_qty && !this.state.pos_data?.order_sell_qty)
     return('dodgerblue');
  else if (!this.state.pos_data.order_buy_qty && this.state.pos_data?.order_sell_qty)
    return('hotpink');
  else
    return('#bc4dff'); //#b233ff //'#9f00ff');
  }

  /*   ---------------------------------------------------------------------   */

  // GetOrdColor()
  // {
  // if (this.state.pos_data?.orders_working        == undefined ||
  //     this.state.pos_data?.orders_working.length == 0)
  //   return('gainsboro')
  // else
  //    return('darkorange')
  // }

  // /*   ---------------------------------------------------------------------   */

  Reset()
  {
  if (this.oTimeOut)
    {
    clearTimeout(this.oTimeOut);
    this.oTimeOut = undefined;
    }
  
    this.oTimeOut = setTimeout(() => 
      {
      clearTimeout(this.oTimeOut);        
      this.oTimeOut = undefined;

      this.setState({rev_pos_enabled:false, can_all_enabled:false, ftn_pos_enabled:false})
      }, 3000);
  }

  /*   ---------------------------------------------------------------------   */

  render() 
  {
   return(
     <>
     <View style={Connection.IsLoggedIn() == false? {display: "none"} : {marginTop:6, padding:2, alignSelf:'center', flexDirection:'column', backgroundColor:FontInfo.sButton, borderRadius:10}}
     onLayout={(
        (event:LayoutChangeEvent)=>{
                this.iControlWidth = event.nativeEvent.layout.width;
                 })}
      >
       <View style={{flexDirection:'row'}}>

       <TouchableOpacity
           style={[{backgroundColor:'transparent', alignItems:'center', alignContent:'center', justifyContent:'center'}]}
           onPress={()=>
             {
             this.props.qbRef?.current?.oOrderRef?.ShowBuyConf("Order Book, Buy Button");
             }}
         >
       <Text style={[FontInfo.appStyles.txt_bold, {backgroundColor:'transparent', minWidth:40, paddingLeft:5, color:'dodgerblue', textAlign:'left', textAlignVertical:'center'}]}>Buy</Text>    
       </TouchableOpacity>    

       <View style={{backgroundColor:'transparent', minWidth:150, flexDirection:'row', alignItems:'center', alignContent:'center', justifyContent:'center'}}>

       <TextWithImage bindEvent={this.props.bindEvent}
             onPress={()=>{this.props.qbRef?.current?.oOrderRef?.ShowSettings(false)}}
             Sample_Image={()=>{return(<Foundation name="dollar" size={18} color={this.props.qbRef?.current?.oOrderRef? this.props.qbRef?.current?.oOrderRef?.GetPNLColor() : 'gainsboro'} />)}}
             getStyle={()=>
               {
                 return([FontInfo.appStyles.txt_bold, {color: this.props.qbRef?.current?.oOrderRef? this.props.qbRef?.current?.oOrderRef?.GetPNLColor() : 'gainsboro', }])
               }} 
               getText={()=>{return( this.props.qbRef?.current?.oOrderRef?.GetPNLText() )}}
               />

            <TextWithImage bindEvent={this.props.bindEvent}
             onPress={this.props.qbRef?.current?.oOrderRef?.ShowSymbolProps}
             Sample_Image={()=>{return(<FontAwesome5 style={{marginLeft:6, marginTop:-2}} name="shopping-bag" size={12} color={this.GetPosColor()} />)}}
             getStyle={()=>
               {
                 return([FontInfo.appStyles.txt_bold, {color: this.GetPosColor() }])
               }} 

             getText={()=>
               {
                 if (this.state.pos_data?.net_qty ||
                     this.state.pos_data?.closed_pnl)
                   return("" + this.state.pos_data?.net_qty + "");
                 else
                   return("");
               }} 
               />

          <TextWithImage bindEvent={this.props.bindEvent}
           onPress={this.props.qbRef?.current?.oOrderRef?.ShowSymbolProps}
           Sample_Image={()=>{return(<Feather style={{marginLeft:4}} name="shopping-cart" size={12} color={this.props.qbRef?.current?.oOrderRef?.GetOrdColor()} />)}}            
           getStyle={()=>{ return(
             this.state.pos_data?.net_qty == undefined? {display:'none'} : [FontInfo.appStyles.txt_bold, {color:this.props.qbRef?.current?.oOrderRef?.GetOrdColor()}]
                                 )}} 
           getText={()=>{return( this.props.qbRef?.current?.oOrderRef?.GetOrderText()  )}}
           />

       </View>

       <TouchableOpacity
           style={[{backgroundColor:'transparent', alignItems:'center', alignContent:'center', justifyContent:'center'}]}
           onPress={()=>
             {
               this.props.qbRef?.current?.oOrderRef?.ShowSellConf("Order Book, Sell Button");
             }}
         >
       <Text style={[FontInfo.appStyles.txt_bold, {minWidth:40, paddingRight:5, backgroundColor:'transparent', color:'hotpink', textAlign:'right'}]}>Sell</Text>
       </TouchableOpacity>    
       </View>

       </View>

       <OBControl oData={this.props.oData}
                  pos_data={this.state.pos_data} 
                  confirm_actions={this.state.confirm_actions}
                  qbRef={this.props.qbRef}
                  ref={node => { this.oOBControls = node; }}
                  def_width={234}
                  def_page={this.GetDefaultControlPage()}
                  />

       </>  
     ); 
  }


  render_old() 
   {
    return(
      <>
      <View style={Connection.IsLoggedIn() == false? {display: "none"} : {marginTop:6, padding:2, alignSelf:'center', flexDirection:'column', backgroundColor:FontInfo.sButton, borderRadius:10}}>
        <View style={{flexDirection:'row'}}>
        {/* <Text style={{fontSize:12}}>Hi</Text> */}

        <TouchableOpacity
            style={[{backgroundColor:'transparent', alignItems:'center', alignContent:'center', justifyContent:'center'}]}
            onPress={()=>
              {
              this.props.qbRef?.current?.oOrderRef?.ShowBuyConf("");
              //this.setState({conf_visible:true, sym_prop_visible:false, buy_conf:true, sell_conf:false  })
              }}
          >
        <Text style={[FontInfo.appStyles.txt_bold, {backgroundColor:'transparent', minWidth:40, paddingLeft:5, color:'dodgerblue', textAlign:'left', textAlignVertical:'center'}]}>Buy</Text>    
        </TouchableOpacity>    

        <View style={{backgroundColor:'transparent', minWidth:150, flexDirection:'row', alignItems:'center', alignContent:'center', justifyContent:'center'}}>

        {/* <FontAwesome5 name="comment-dollar" size={13} color="gainsboro" />   */}
        <TextWithImage bindEvent={this.props.bindEvent}
              onPress={()=>{this.props.qbRef?.current?.oOrderRef?.ShowSettings(false)}}
              Sample_Image={()=>{return(<Foundation name="dollar" size={18} color={this.props.qbRef?.current?.oOrderRef? this.props.qbRef?.current?.oOrderRef?.GetPNLColor() : 'gainsboro'} />)}}
              getStyle={()=>
                {
                  return([FontInfo.appStyles.txt_bold, {color: this.props.qbRef?.current?.oOrderRef? this.props.qbRef?.current?.oOrderRef?.GetPNLColor() : 'gainsboro', }])
                //   if (this.state.pos_data?.net_qty != undefined && 
                //       this.state.pos_data?.net_qty != 0)
                    
                //     {
                //     if (this.state.pos_data?.open_pnl == undefined)  
                //       return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'gainsboro', textAlign:'right'}])
                //     else if (this.state.pos_data?.open_pnl >= 0)
                //       return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'green', textAlign:'right'}])
                //     else
                //       return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'red', textAlign:'right'}])
                //     }
                // else
                //     {
                //     if (this.state.pos_data?.closed_pnl == undefined)
                //       return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'gainsboro', textAlign:'right'}])
                //     else if (this.state.pos_data?.closed_pnl >= 0)
                //       return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'green', textAlign:'right'}])
                //     else
                //       return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'red', textAlign:'right'}])
                //     }
                }} 
                getText={()=>{return( this.props.qbRef?.current?.oOrderRef?.GetPNLText() )}}
                // ()=>
                // {
                //   if (this.state.pos_data?.net_qty)
                //     return(this.state.pos_data?.open_pnl);
                //   else
                //     return(this.state.pos_data?.closed_pnl);
                // }} 
                />

             {/* <FontAwesome5 style={{marginLeft:8, marginTop:-2}} name="shopping-bag" size={12} color="gainsboro" /> */}
             <TextWithImage bindEvent={this.props.bindEvent}
              onPress={this.props.qbRef?.current?.oOrderRef?.ShowSymbolProps}
              Sample_Image={()=>{return(<FontAwesome5 style={{marginLeft:6, marginTop:-2}} name="shopping-bag" size={12} color={this.GetPosColor()} />)}}
              getStyle={()=>
                {
                  return([FontInfo.appStyles.txt_bold, {color: this.GetPosColor() }])
                  // if (this.state.pos_data?.net_qty == undefined || 
                  //     this.state.pos_data?.net_qty == 0)
                  //   return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'gainsboro' }])
                  // else if (this.state.pos_data?.net_qty > 0)
                  //   return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'dodgerblue' }])
                  // else
                  //   return([{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color: 'hotpink' }])
                }} 

              //getText={()=>{return( this.props.qbRef?.current?.oOrderRef?.GetPNLText() )}}  

              getText={()=>
                {
                  if (this.state.pos_data?.net_qty ||
                      this.state.pos_data?.closed_pnl)
                    return("" + this.state.pos_data?.net_qty + "");
                  else
                    return("");
                }} 
                
                />

          {/* <Feather style={{marginLeft:4}} name="shopping-cart" size={12} color="gainsboro" /> */}
          {/* <OBChange
            bindEvent={this.props.bindEvent} 
            getStyle={()=>{ return(this.state.pos_data?.net_qty == undefined? {display:'none'} : this.state.pos_data?.orders_working.length > 0? {borderRadius:5, marginLeft:4, backgroundColor:'green'} : {borderRadius:5, marginLeft:4, backgroundColor:'gray'}
                                  )}} 
            style={{fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color:'white',}}
            getText={()=>{return( this.state.pos_data?.net_qty == undefined? "" : this.state.pos_data?.orders_working.length.toString() )}}
            /> */}
           <TextWithImage bindEvent={this.props.bindEvent}
            onPress={this.props.qbRef?.current?.oOrderRef?.ShowSymbolProps}
            Sample_Image={()=>{return(<Feather style={{marginLeft:4}} name="shopping-cart" size={12} color={this.props.qbRef?.current?.oOrderRef?.GetOrdColor()} />)}}            
            getStyle={()=>{ return(
              this.state.pos_data?.net_qty == undefined? {display:'none'} : [FontInfo.appStyles.txt_bold, {color:this.props.qbRef?.current?.oOrderRef?.GetOrdColor()}]
              // this.state.pos_data?.net_qty == undefined? {display:'none'} : this.state.pos_data?.orders_working.length > 0? {fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color:'green'} : {fontVariant: ['tabular-nums'], fontSize:12, fontWeight:'bold', color:'gainsboro'} //{borderRadius:5, marginLeft:4, backgroundColor:'green'} : {borderRadius:5, marginLeft:4, backgroundColor:'gray'}
                                  )}} 
            getText={()=>{return( this.props.qbRef?.current?.oOrderRef?.GetOrderText() /*this.state.pos_data?.net_qty == undefined? "" : this.state.pos_data?.orders_working.length.toString()*/ )}}
            />

        </View>

        <TouchableOpacity
            style={[{backgroundColor:'transparent', alignItems:'center', alignContent:'center', justifyContent:'center'}]}
            onPress={()=>
              {

                this.props.qbRef?.current?.oOrderRef?.ShowSellConf("Order Book, Sell Button");

                //this.setState({conf_visible:true, sym_prop_visible:false, buy_conf:false, sell_conf:true})
                // ConnectionOrd.oConn?.PlaceOrder(this.state.pos_data?.acc_id, 
                //   this.props.data.token,
                //   TransactionType.SELL,
                //   1)
              }}
          >
        <Text style={[FontInfo.appStyles.txt_bold, {minWidth:40, paddingRight:5, backgroundColor:'transparent', color:'hotpink', textAlign:'right'}]}>Sell</Text>
        </TouchableOpacity>    
        </View>

        </View>


        <View style={{alignSelf:'center', flexDirection:'row'}}>
          <TouchableOpacity style={{backgroundColor:!this.state.rev_pos_enabled? FontInfo.sButton : 'royalblue', marginVertical:5, marginHorizontal:3, minWidth:55, borderRadius:10, alignItems:'center', justifyContent:'center'}}
            onPress={()=>{
                    if (Connection.IsOrderAvailable() == false)
                      {
                      this.props.qbRef?.current?.oOrderRef?.ShowNoOrder();  
                      return;
                      }

                    if (this.state.rev_pos_enabled || this.state.confirm_actions == false)
                    {
                    if (this.state.pos_data          &&
                        this.state.pos_data?.net_qty &&
                        this.state.pos_data?.net_qty != 0)
                      {
                      ConnectionOrd.oConn?.Rq_PlaceOrder(this.state.pos_data?.acc_key,
                                                         this.props.oData.token,
                                                         this.state.pos_data?.net_qty < 0?
                                                         TransactionType.BUY : TransactionType.SELL,
                                                         Math.abs(2 * this.state.pos_data?.net_qty),
                                                         "Window Menu, Reverse Pos Button");
                      }
                
                    if (this.state.confirm_actions == true)
                      this.setState({rev_pos_enabled:false, can_all_enabled:false, ftn_pos_enabled:false});
                    }
                  else
                    {
                    this.setState({rev_pos_enabled:true, can_all_enabled:false, ftn_pos_enabled:false});

                    this.Reset();
                    }
                  // alert(this.state.rev_pos_enabled);
                  }}
            >
            <Text style={[FontInfo.appStyles.txt_bold, {paddingVertical:2, paddingHorizontal:5, color:!this.state.rev_pos_enabled? 'royalblue' : 'white', }]}>Reverse Pos</Text>
           </TouchableOpacity>

           <TouchableOpacity style={{backgroundColor:!this.state.can_all_enabled? FontInfo.sButton : 'darkorange', marginVertical:5, marginHorizontal:3, minWidth:55, borderRadius:10, alignItems:'center', justifyContent:'center'}}
           onPress={()=>{
                  if (Connection.IsOrderAvailable(false) == false)
                      {
                      if (this.props.qbRef?.current?.oOrderRef)                        
                        this.props.qbRef?.current?.oOrderRef?.ShowNoOrder();  
                      else
                        alert("Order not available");
  
                      return;
                      }

                  if (!this.state.pos_data)
                    {
                    alert("Position not available");
                    return;
                    }

                  if (this.state.can_all_enabled || this.state.confirm_actions == false)
                    {
                    ConnectionOrd.oConn?.Rq_CancelAllOrders(this.state.pos_data, 
                                                            "Window Menu, Cancel All Button");

                    if (this.state.confirm_actions == true)
                      this.setState({rev_pos_enabled:false, can_all_enabled:false, ftn_pos_enabled:false});
                    }
                  else
                    {
                    this.setState({rev_pos_enabled:false, can_all_enabled:true, ftn_pos_enabled:false});

                    this.Reset();
                    }
                  }}
           >
            <Text style={[FontInfo.appStyles.txt_bold, {paddingVertical:2, color:!this.state.can_all_enabled? 'darkorange' : 'white', paddingHorizontal:5, }]}>Cancel All</Text>
           </TouchableOpacity>

          <TouchableOpacity style={{backgroundColor:!this.state.ftn_pos_enabled? FontInfo.sButton : '#ef3038', marginVertical:5, marginHorizontal:3, minWidth:55, borderRadius:10, alignItems:'center', justifyContent:'center'}}
          onPress={()=>{
                  if (Connection.IsOrderAvailable() == false)
                    {
                    if (this.props.qbRef?.current?.oOrderRef)
                      this.props.qbRef?.current?.oOrderRef?.ShowNoOrder(); 
                    else
                      alert("Order not available");

                    return;
                    }

                  if (!this.state.pos_data)
                    {
                    alert("Position not available");
                    return;
                    }

                  if (this.state.ftn_pos_enabled || this.state.confirm_actions == false)
                    {
                    if (this.state.pos_data && this.state.pos_data?.orders_working.length > 0)
                      {
                      ConnectionOrd.oConn?.Rq_CancelAllOrders(this.state.pos_data,
                                                              "Window Menu, Cncl All & Fltn Button");
                      }
                
                    if (this.state.pos_data)
                      {
                      ConnectionOrd.oConn?.Rq_ExitPosition(this.state.pos_data?.acc_key,
                                                           this.props.oData.token,
                                                           "Window Menu, Cncl All & Fltn Button");
                      }


/*                     if (this.state.pos_data          &&
                        this.state.pos_data?.net_qty &&
                        this.state.pos_data?.net_qty != 0)
                      {
                      ConnectionOrd.oConn?.Rq_PlaceOrder(this.state.pos_data?.acc_key,
                                                         this.props.oData.token,
                                                         this.state.pos_data?.net_qty < 0?
                                                         TransactionType.BUY : TransactionType.SELL,
                                                         Math.abs(this.state.pos_data?.net_qty))
                      }
 */
                    if (this.state.confirm_actions == true)
                      this.setState({rev_pos_enabled:false, can_all_enabled:false, ftn_pos_enabled:false});
                    }
                  else
                    {
                    this.setState({rev_pos_enabled:false, can_all_enabled:false, ftn_pos_enabled:true});

                    this.Reset();
                    }
                  }}
          >
            <Text style={[FontInfo.appStyles.txt_bold, {paddingVertical:2, paddingHorizontal:5, color:!this.state.ftn_pos_enabled? '#ef3038' : 'white', }]}>Cncl All & Fltn</Text>
           </TouchableOpacity>                      
           {/* #f5f6fa */}
        </View>  

        </>  
      ); 

   }
}

/*   =====================================================================   */

